import React, { Component } from 'react';

export class ColorDisplayer extends Component {
    render() {
        const { color, cursor, onClick } = this.props;

        return (
            <div>
                <span
                    className="span-colors"
                    style={{
                        backgroundColor: color,
                        cursor: undefined === cursor ? "default" : cursor
                    }}
                    onClick={onClick}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ColorDisplayer.js